<template>
    <ListadoEvento :event="event">
        <div class="m-0 text-center">
            <router-link
                v-if="!isLiberado"
                :to="{ name: 'liberar-asiento-sesion', params: { abono_id: abono_id, evento_id: event.id } }"
                class="button large-button effect-button"
            >{{ $t('perfil.asiento_no_liberado') }}</router-link>
            <button v-else class="button large-button effect-button" disabled>{{ $t('perfil.asiento_liberado') }}</button>
            <p v-if="event.importe_monedero_abonado && event.importe_monedero_abonado > 0" style="font-size: 10.5px; font-weight: 700; max-width: 70%;" class="mx-auto">
                {{ $t(refundTextKey, { importe: event.importe_monedero_abonado }) }}
            </p>
        </div>
    </ListadoEvento>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import store from '@/store';
    import { useSeatReleaseRules } from '@/composables/front/perfil/useSeatReleaseRules';
    import ListadoEvento from '@/components/common/ListadoEvento';

    const props = defineProps({
        event: {
            type: Object,
            required: true
        },
        abono_id: {
            type: [String, Number],
            required: true
        },
        mensaje: {
            type: String,
            required: false,
            default: ''
        }
    });

    const mensajeLocal = ref(props.mensaje);
    const teatro = computed(() => store.getters.getTeatro);

    const { refundTextKey } = useSeatReleaseRules(teatro);

    const isLiberado = computed(() => props.event.asientos_liberados || mensajeLocal.value === 'Asiento liberado correctamente');
</script>

<style scoped>
    .info_fecha {
        margin-left: 13px; 
        margin-top: 3px;
    }

    @media (max-width: 1024px) {
        .large-button {
            width: 40wv !important;
        }
    }

    @media (max-width: 768px) {
        .info_fecha {
            margin-left: 0; 
        }
    }
</style>
